var exports = {
  "k": "xf61da738--6c04a5--container",
};

module.exports = exports;
